<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="库存管理"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
      <div class="search_pro">
        <van-search v-model="gooodsName" placeholder="请输入要搜索的商品名" />
      </div>
    </div>
    <div class="all">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell class="lists" v-for="(item, index) in list" :key="index">
            <div>
              <van-row>
                <van-col span="24" class="goods_info">
                  <div class="img">
                    <img :src="item.thumb" />
                    <p v-if="item.status == 7">已售罄</p>
                    <p v-if="item.status == 1" class="normal">已上架</p>
                  </div>
                  <p class="name">{{ item.name }}</p>
                  <p class="money">
                    采购价：<span
                      >￥{{ item.min_cost_price }}-{{
                        item.max_cost_price
                      }}</span
                    >
                  </p>
                  <p class="stock">
                    库存：<span>{{ item.inventory }}</span>
                  </p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="24" class="btns">
                  <btn
                    :btntext="'修改库存'"
                    :btnwidth="'8rem'"
                    :height="'3.2rem'"
                    :bgcolor="'#fff'"
                    :borderradius="'1.6rem'"
                    :btncolor="'#333'"
                    :fontsize="'1.5rem'"
                    :btnborder="'solid 0.05rem #ccc'"
                    @btnClick="changeStock(item)"
                  />
                </van-col>
              </van-row>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <van-row class="empty" v-if="list.length == 0 && !hasList">
        <van-col class="emptyMsg" span="24">
          <img src="../../../assets/purchaseSupplier/common/no_info.png" />
          <p class="tip">无内容</p>
        </van-col>
      </van-row>
      <div class="loading" v-if="list.length <= 0 && hasList">
        <img src="../../../assets/accountAgent/common/loading.gif" />
      </div>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      gooodsName: "",
    };
  },
  created() {
    this.getInfo();
  },
  watch: {
    gooodsName() {
      this.page = 1;
      this.list = [];
      this.getInfo();
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      this.$api
        .post("/ongoods/member/goods/supplier/goods/list", {
          page: this.page,
          search: this.gooodsName,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    changeStock(item) {
      this.$router.push({
        path: "/purchaseSupplier/changeStock",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;

    .search_pro {
      height: 4.6rem;
      padding: 0.5rem 2rem 0;

      .van-search {
        height: 3.4rem;
        line-height: 3.4rem;
        padding: 0;

        .van-search__content {
          padding-left: 1.8rem;
          line-height: 2rem;
          font-size: 1.2rem;
          border-radius: 1.8rem;

          .van-cell {
            height: 3rem;
            border-radius: 1.5rem;
            font-size: 1.2rem;
          }
        }
      }
    }
  }

  .all {
    padding-top: 13.9rem;
    box-sizing: border-box;
    height: 100%;

    .van-pull-refresh {
      height: 100%;
      padding: 1.2rem 1.6rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .lists {
        height: 15rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0;

        .goods_info {
          height: 10.2rem;
          font-size: 1.2rem;
          color: #333;
          padding: 2rem 1.2rem 1.2rem;
          box-sizing: border-box;
          position: relative;

          .img {
            width: 7rem;
            height: 7rem;
            float: left;
            position: relative;

            img {
              width: 7rem;
              height: 7rem;
            }

            p {
              width: 7rem;
              padding: 0;
              color: #fff;
              font-size: 1.1rem;
              height: 2rem;
              line-height: 2rem;
              text-align: center;
              position: absolute;
              left: 0;
              bottom: 0;
              background: rgba(219, 0, 0, 0.6);
            }

            .normal {
              background: rgba(0, 0, 0, 0.6);
            }
          }

          p {
            height: 2rem;
            line-height: 2rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-left: 1.2rem;
          }

          .name {
            font-weight: 700;
            font-size: 1.4rem;
          }

          .money {
            margin: 0.6rem 0;
            span {
              font-size: 1.4rem;
              color: #ff4747;
              font-weight: 700;
            }
          }

          .stock {
            height: 1.8rem;
            line-height: 1.8rem;

            span {
              font-size: 1.4rem;
              font-weight: 700;
            }
          }
        }

        .btns {
          text-align: right;
          padding: 0 1.2rem;
        }
      }
    }

    .empty {
      padding-top: 10rem;

      .emptyMsg {
        text-align: center;

        img {
          width: 16rem;
          display: inline-block;
        }

        .tip {
          color: #cccccc;
          font-size: 1.4rem;
          margin-top: 1.7rem;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }
  }
}
</style>




